import { Shield, Clock, Award, ThumbsUp, Users, FileCheck } from 'lucide-react';

const reasons = [
  {
    icon: Shield,
    title: 'Über 10 Jahre Erfahrung',
    description: 'Mehr als 2000 erfolgreiche Umzüge nach Deutschland – wir kennen jeden Grenzübergang, jede Zollbestimmung und jeden Trick für einen reibungslosen Umzug Schweiz Deutschland.',
  },
  {
    icon: FileCheck,
    title: 'Komplette Zollabwicklung',
    description: 'Sie müssen sich um nichts kümmern. Wir erstellen alle Dokumente, wickeln den Zoll ab und sorgen für einen stressfreien Grenzübertritt.',
  },
  {
    icon: Award,
    title: 'Fixpreis-Garantie',
    description: 'Nach der Besichtigung erhalten Sie einen transparenten Fixpreis – ohne versteckte Kosten, ohne böse Überraschungen. Was vereinbart ist, gilt.',
  },
  {
    icon: Clock,
    title: '24-48h Express möglich',
    description: 'Zeitdruck? Kein Problem! Wir realisieren auch kurzfristige Umzüge innerhalb von 24-48 Stunden und sind flexibel bei der Terminwahl.',
  },
  {
    icon: Users,
    title: 'Professionelles Team',
    description: 'Unser erfahrenes Team behandelt Ihre Möbel wie die eigenen. Mit Sorgfalt, Respekt und höchster Professionalität – von der ersten Kiste bis zum letzten Bild.',
  },
  {
    icon: ThumbsUp,
    title: 'Rundum-Sorglos-Paket',
    description: 'Verpackung, Transport, Zoll, Montage, Versicherung – alles aus einer Hand. Sie lehnen sich zurück, wir erledigen den Rest.',
  },
];

const stats = [
  { number: '10+', label: 'Jahre Erfahrung' },
  { number: '500+', label: 'Umzüge pro Jahr' },
  { number: '98%', label: 'Kundenzufriedenheit' },
  { number: '24/7', label: 'Erreichbarkeit' },
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Ihre Umzugsfirma nach Deutschland
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Umzug nach Deutschland: Ihr Partner für Umzug Schweiz Deutschland
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Auswandern nach Deutschland oder beruflicher Umzug? Als spezialisierte Umzugsfirma nach Deutschland machen wir Ihren Umzug Schweiz Deutschland stressfrei durch Erfahrung, Zuverlässigkeit und Komplettservice.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mb-20">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 group hover:shadow-xl hover:-translate-y-2"
              >
                <div className="bg-slate-800 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold mb-4">Zahlen, die überzeugen</h3>
            <p className="text-slate-300 text-lg">
              Vertrauen Sie auf über ein Jahrzehnt Erfahrung im internationalen Umzugsgeschäft
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl md:text-6xl font-bold mb-2 bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
                  {stat.number}
                </div>
                <div className="text-slate-300 text-lg">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-slate-200 mb-6 text-lg">
              Bereit für Ihren stressfreien Umzug? Lassen Sie sich jetzt kostenlos beraten!
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button
                onClick={() => {
                  const element = document.getElementById('kontakt');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-white hover:bg-slate-100 text-slate-900 px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105"
              >
                Kostenlose Offerte anfordern
              </button>
              <a
                href="tel:0800700100"
                className="bg-slate-700 hover:bg-slate-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 border-2 border-slate-600 hover:scale-105"
              >
                0800 700 100 (Gratis)
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
